import { useEffect } from 'react';
import { APP } from '@/config';

/**
 * Sets the document title and description for a route.
 *
 * Vite has no metadata API, so this is a small effect rather than anything
 * framework-provided. Three of the four portals are behind a login and
 * noindexed, so this is for the browser tab and for people with many tabs open
 * rather than for search engines.
 */
export function Meta({ title, description }: { title: string; description?: string }) {
  useEffect(() => {
    const previous = document.title;
    document.title = `${title} · ${APP.name}`;

    if (description) {
      const tag = document.querySelector<HTMLMetaElement>('meta[name="description"]');
      tag?.setAttribute('content', description);
    }

    return () => {
      document.title = previous;
    };
  }, [title, description]);

  return null;
}
